import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function allPaymentReportsLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/all_payments`;
  const method = 'GET'

  return {
    type: 'ALL_PAYMENTS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function cashBalanceDueLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/cash_balance_due`;
  const method = 'GET'

  return {
    type: 'CASH_BALANCE_DUE_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function claimDetailsLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/claim_detail`;
  const method = 'GET'

  return {
    type: 'CLAIM_DETAILS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function agedClaimsLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/aged_claim`;
  const method = 'GET'

  return {
    type: 'AGED_CLAIMS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function netSaleByPayersLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/net_sale_by_payer`;
  const method = 'GET'

  return {
    type: 'NET_SALE_BY_PAYERS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function orderDetailsLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/order_details`;
  const method = 'GET'

  return {
    type: 'ORDER_DETAILS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function paymentReportExport(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/export`;
  const method = 'GET'

  return {
    type: 'PAYMENT_REPORT_EXPORT',
    payload: handleAPI(url, filters, method)
  };
}


export function printPatientStatement(id, filters) {
  const url = `/${API_VERSION_ONE}/orders/${id}/patient_statement`;
  const method = 'GET'

  return {
    type: 'PATIENT_STATEMENT_PRINT',
    payload: handleAPI(url, filters, method)
  };
}

export function resetReducer() {
  return {
    type: 'RESET_OTHER_PAYMENT_REPORT'
  };
}

export function paymentReportEdit(data) {
  return {
    type: 'PAYMENT_REPORT_EDIT',
    payload: data
  };
}

export function paymentReportEditCancel() {
  return {
    type: 'PAYMENT_REPORT_EDIT_CANCEL'
  };
}

export function paymentReportUpdateEdit(order) {
  return {
    type: 'PAYMENT_REPORT_UPDATE_EDIT',
    payload: { data: { order } }
  };
}

export function sellingReportPaymentLoad(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/selling_report`;
  const method = 'GET'

  return {
    type: 'SELLING_REPORT_LOAD',
    payload: handleAPI(url, filters, method)
  };
}


export function sellingReportPreview(filters) {
  const url = `/${API_VERSION_ONE}/payment_reports/preview_selling_report`;
  const method = 'GET'

  return {
    type: 'SELLING_REPORT_PREVIEW',
    payload: handleAPI(url, filters, method)
  };
}
